/* src/components/suggestions/SuggestionBox.js */

// Shared Suggestion Box entry point.
//
// Rendered by BOTH portals:
//   Admin Portal → <SuggestionBox viewerRole="admin" />
//   Tutor Portal → <SuggestionBox viewerRole="tutor" />
//
// The viewer's role decides what the dashboard shows: admins see every
// submitted suggestion and can manage them (mark read / completed / delete),
// while tutors see only the suggestions they submitted themselves.

import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../firebaseConfig";

import SuggestionsDashboard from "./SuggestionsDashboard";

import "./SuggestionBox.css";

async function loadProfile(user) {
  if (!user) return null;
  try {
    const snap = await getDoc(doc(db, "users", user.uid));
    const data = snap.exists() ? snap.data() || {} : {};
    return {
      uid: user.uid,
      email: user.email || data.email || "",
      name: data.name || user.displayName || "User",
      role: data.role || "unknown",
    };
  } catch (e) {
    return {
      uid: user.uid,
      email: user.email || "",
      name: user.displayName || "User",
      role: "unknown",
    };
  }
}

export default function SuggestionBox({ viewerRole = "tutor" }) {
  const [me, setMe] = useState(null);
  const [profileResolved, setProfileResolved] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setMe(null);
        setProfileResolved(true);
        return;
      }
      const prof = await loadProfile(user);
      setMe(prof);
      setProfileResolved(true);
    });
    return () => unsub();
  }, []);

  // Prefer the live profile role, but fall back to the prop the portal passed
  // in so the page still renders correctly if the users/{uid} read fails.
  const isAdmin = viewerRole === "admin" || me?.role === "admin";

  return (
    <div className="sgShell">
      <div className="sgShellInner">
        <SuggestionsDashboard me={me} isAdmin={isAdmin} ready={profileResolved} />
      </div>
    </div>
  );
}
